import { Avatar, getAvatarColor } from '@raystack/apsara';
import { Organization } from '@raystack/frontier';

import { getInitials } from '@src/utils';

export const OrgAvatar = ({
  org,
  ...props
}: React.ComponentProps<typeof Avatar> & { org: Organization }) => {
  const initials = getInitials(org);
  return (
    <Avatar
      alt={org?.name}
      src={org?.avatar}
      fallback={initials}
      color={getAvatarColor(org.id || '')}
      {...props}
    />
  );
};
